import React from 'react';
import OwnerShell from './OwnerShell';
import Profile from './Profile';

/**
 * ProfilePage
 *
 * Keep `Profile`'s embedded form UI, but render it inside the shared OwnerShell
 * so the sidebar navigation is consistent across all owner pages.
 */
export default function ProfilePage() {
  return (
    <OwnerShell>
      <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 20px 40px' }}>
        <Profile embedded />
      </div>
    </OwnerShell>
  );
}

